class HandCannonBuilder {
    constructor() {
        this.selectedItems = new Map();
        this.lastClickedItem = new Map();
        this.compatibilityRules = [];
        this.previousMainImage = null;
        this.parseCompatibilityRules();
        this.init();
    }

    init() {
        this.bindEvents();
        this.initColorSwatches();
        this.updateStepInfo();
        this.updateCompatibility();
    }

    initColorSwatches() {
        const swatches = document.querySelectorAll('.color-swatch');
        if (!swatches.length) return;

        const defaultSwatch = document.querySelector('.color-swatch.selected') || swatches[0];
        if (defaultSwatch && !defaultSwatch.classList.contains('selected')) {
            defaultSwatch.classList.add('selected');
        }
        this.selectedColor = defaultSwatch ? defaultSwatch.dataset.color : null;
        this.filterStep1ByColor(this.selectedColor);

        swatches.forEach(swatch => {
            swatch.addEventListener('click', () => {
                if (swatch.classList.contains('selected')) return;

                // Remember currently selected size before clearing
                const step1 = document.querySelector('.builder-step[data-step="1"]');
                const currentlySelected = step1.querySelector('.option-item.selected');
                const previousSize = currentlySelected ? currentlySelected.dataset.size : null;

                swatches.forEach(s => s.classList.remove('selected'));
                swatch.classList.add('selected');

                const colorNameEl = document.getElementById('selectedColorName');
                if (colorNameEl) colorNameEl.textContent = swatch.dataset.color;

                this.selectedColor = swatch.dataset.color;

                // Clear step 1 selection
                step1.querySelectorAll('.option-item').forEach(opt => opt.classList.remove('selected'));
                this.selectedItems.delete('step-1');
                this.lastClickedItem.delete('step-1');

                this.filterStep1ByColor(this.selectedColor);

                // Auto-select the equivalent size in the new color
                if (previousSize) {
                    const equivalent = step1.querySelector(`.option-item[data-size="${previousSize}"][data-color="${this.selectedColor}"]`);
                    if (equivalent) equivalent.click();
                }

                // Update main image for any selected items in steps 2/3 to use correct color
                this.updateColorAwareMainImage();

                this.updateStepInfo();
                this.updateSummary();
                this.updateCompatibility();
            });
        });
    }

    getMainImage(item) {
        const step1Selected = document.querySelector('.builder-step[data-step="1"] .option-item.selected');
        const handleColor = step1Selected ? step1Selected.dataset.color : this.selectedColor;
        if (handleColor === 'Black' && item.dataset.variantMainImageBlack) {
            return item.dataset.variantMainImageBlack;
        }
        return item.dataset.variantMainImage || item.dataset.variantImage;
    }

    updateColorAwareMainImage() {
        const mainImageEl = document.getElementById('builderMainImage');
        if (!mainImageEl) return;

        for (let i = 3; i >= 1; i--) {
            const step = document.querySelector(`.builder-step[data-step="${i}"]`);
            if (!step) continue;
            const selectedItem = step.querySelector('.option-item.selected');
            if (selectedItem) {
                const img = this.getMainImage(selectedItem);
                if (img) mainImageEl.src = img;
                return;
            }
        }
    }

    filterStep1ByColor(color) {
        const step1 = document.querySelector('.builder-step[data-step="1"]');
        if (!step1) return;

        step1.querySelectorAll('.option-item[data-color]').forEach(item => {
            item.style.display = (!color || item.dataset.color === color) ? '' : 'none';
        });
    }

    parseCompatibilityRules() {
        const builderElement = document.querySelector('.hand-cannon-builder');
        const rulesData = builderElement?.dataset.compatibilityRules;

        if (rulesData && rulesData !== 'null' && rulesData !== '') {
            try {
                this.compatibilityRules = JSON.parse(rulesData);
            } catch (e) {
                console.error('Failed to parse compatibility rules:', e);
                this.compatibilityRules = [];
            }
        }
    }

    bindEvents() {
        // Option item clicks
        document.querySelectorAll('.option-item').forEach(item => {
            item.addEventListener('click', (e) => this.handleOptionClick(e));
            item.addEventListener('mouseenter', (e) => this.showPopover(e));
            item.addEventListener('mouseleave', () => this.hidePopover());
        });

        // Add to cart button
        document.getElementById('addAllToCart')?.addEventListener('click', () => this.addAllToCart());

        // Error modal close buttons
        document.getElementById('closeErrorModal')?.addEventListener('click', () => this.hideErrorModal());
        document.getElementById('errorModalButton')?.addEventListener('click', () => this.hideErrorModal());
        document.querySelector('.error-modal-overlay')?.addEventListener('click', () => this.hideErrorModal());
    }

    handleOptionClick(e) {
        const item = e.currentTarget;
        const step = item.closest('.builder-step');
        const selectionType = step.querySelector('.step-options').dataset.selectionType;
        const stepNum = step.dataset.step;

        // Prevent selection of disabled items
        if (item.classList.contains('disabled-option')) {
            return;
        }

        // Handle clear selection button
        if (item.classList.contains('clear-selection')) {
            step.querySelectorAll('.option-item:not(.clear-selection)').forEach(opt => opt.classList.remove('selected'));
            this.selectedItems.delete(`step-${stepNum}`);
            this.lastClickedItem.delete(`step-${stepNum}`);

            // Revert main image to step 1 selection
            const step1Item = this.lastClickedItem.get('step-1');
            if (step1Item) {
                const mainImageElement = document.getElementById('builderMainImage');
                const step1Image = mainImageElement.dataset.defaultSrc;
                // Try to get the actual step 1 selected image, otherwise use default
                if (step1Item.image) {
                    const step1SelectedItem = document.querySelector(`.builder-step[data-step="1"] .option-item[data-variant-id="${step1Item.variantId}"]`);
                    if (step1SelectedItem) {
                        const step1MainImage = this.getMainImage(step1SelectedItem);
                        if (step1MainImage) {
                            mainImageElement.src = step1MainImage;
                        }
                    }
                } else {
                    mainImageElement.src = step1Image;
                }
            }

            this.updateStepInfo();
            this.updateSummary();
            this.updateCompatibility();
            return;
        }

        // Store the last clicked item for this step
        this.lastClickedItem.set(`step-${stepNum}`, {
            variantId: item.dataset.variantId,
            productId: item.dataset.productId,
            title: item.dataset.variantTitle,
            price: item.dataset.variantPrice,
            image: item.dataset.variantImage,
            sku: item.dataset.variantSku,
            available: item.dataset.variantAvailable,
            quantity: item.dataset.variantQuantity
        });

        if (selectionType === 'single') {
            // Clear other selections in this step
            step.querySelectorAll('.option-item').forEach(opt => opt.classList.remove('selected'));
            item.classList.add('selected');

            // Update selected items
            this.selectedItems.set(`step-${stepNum}`, [{
                variantId: item.dataset.variantId,
                productId: item.dataset.productId,
                productTitle: item.dataset.productTitle,
                title: item.dataset.variantTitle,
                price: item.dataset.variantPrice,
                image: item.dataset.variantImage,
                sku: item.dataset.variantSku,
                available: item.dataset.variantAvailable,
                quantity: item.dataset.variantQuantity
            }]);
        } else {
            // Toggle selection for multiple choice
            const wasSelected = item.classList.contains('selected');
            const mainImageElement = document.getElementById('builderMainImage');

            // Store current image before any changes (only if we're selecting, not deselecting)
            if (!wasSelected && stepNum !== '4') {
                this.previousMainImage = mainImageElement.src;
            }

            item.classList.toggle('selected');

            // Update selected items
            const selectedInStep = Array.from(step.querySelectorAll('.option-item.selected')).map(opt => ({
                variantId: opt.dataset.variantId,
                productId: opt.dataset.productId,
                productTitle: opt.dataset.productTitle,
                title: opt.dataset.variantTitle,
                price: opt.dataset.variantPrice,
                image: opt.dataset.variantImage,
                sku: opt.dataset.variantSku,
                available: opt.dataset.variantAvailable,
                quantity: opt.dataset.variantQuantity
            }));

            if (selectedInStep.length > 0) {
                this.selectedItems.set(`step-${stepNum}`, selectedInStep);
            } else {
                this.selectedItems.delete(`step-${stepNum}`);
                this.lastClickedItem.delete(`step-${stepNum}`);
            }

            // Update main image (skip for step 4 - ammo)
            if (stepNum !== '4') {
                if (!wasSelected) {
                    // Was just selected - update to new image
                    const mainImage = this.getMainImage(item);
                    if (mainImage) {
                        mainImageElement.src = mainImage;
                    }
                } else {
                    // Was just deselected - find the most recent selected item's image
                    // Check steps in reverse order (current step, then earlier steps)
                    let revertImage = null;

                    // Check if there are other selected items in the current step
                    const currentStepSelected = step.querySelector('.option-item.selected');
                    if (currentStepSelected) {
                        revertImage = this.getMainImage(currentStepSelected);
                    }

                    // If no image found in current step, check earlier steps (3, 2, 1)
                    if (!revertImage) {
                        for (let i = parseInt(stepNum) - 1; i >= 1; i--) {
                            const previousStep = document.querySelector(`.builder-step[data-step="${i}"]`);
                            if (previousStep && i !== 4) {
                                const selectedItem = previousStep.querySelector('.option-item.selected');
                                if (selectedItem) {
                                    revertImage = this.getMainImage(selectedItem);
                                    if (revertImage) break;
                                }
                            }
                        }
                    }

                    // If still no image, use default product image
                    if (!revertImage) {
                        revertImage = mainImageElement.dataset.defaultSrc;
                    }

                    if (revertImage) {
                        mainImageElement.src = revertImage;
                    }

                    this.previousMainImage = null;
                }
            }
        }

        // Update main image for single selection (skip for step 4 - ammo)
        if (selectionType === 'single' && stepNum !== '4') {
            const mainImage = this.getMainImage(item);
            if (mainImage) {
                document.getElementById('builderMainImage').src = mainImage;
            }
        }

        // Update builder price if step 1 is selected
        if (stepNum === '1') {
            const priceElement = document.querySelector('.builder-price');
            if (priceElement && item.dataset.variantPrice) {
                priceElement.textContent = item.dataset.variantPrice;
            }
        }

        // Update step info
        this.updateStepInfo();

        // Update summary
        this.updateSummary();

        // Update compatibility
        this.updateCompatibility();
    }

    updateStepInfo() {
        document.querySelectorAll('.builder-step').forEach((step) => {
            const stepNum = parseInt(step.dataset.step);
            const infoDiv = step.querySelector('.step-info');

            // Get the last clicked item for this step
            const lastItem = this.lastClickedItem.get(`step-${stepNum}`);
            if (lastItem) {
                const quantity = parseInt(lastItem.quantity) || 0;
                const stockStatus = quantity >= 1 ? 'In Stock' : 'Back Ordered';
                const stockClass = quantity >= 1 ? 'in-stock' : 'back-ordered';
                infoDiv.innerHTML = `
            <div class="info-item">
              <span class="info-label">Status:</span> <span class="stock-status ${stockClass}">${stockStatus}</span> | 
              <span class="info-label">SKU:</span> ${lastItem.sku}
            </div>
          `;
            } else {
                infoDiv.innerHTML = '';
            }
        });
    }

    showPopover(e) {
        const item = e.currentTarget;

        // Don't show popover for clear buttons
        if (item.classList.contains('clear-selection')) {
            return;
        }

        const popover = document.getElementById('builderPopover');

        const title = item.dataset.variantTitle;
        const price = item.dataset.variantPrice;
        const quantity = parseInt(item.dataset.variantQuantity) || 0;
        const sku = item.dataset.variantSku;
        const stockStatus = quantity >= 1 ? 'In stock' : 'Back Ordered';
        const stockClass = quantity >= 1 ? 'in-stock' : 'back-ordered';

        popover.querySelector('.popover-title').textContent = title;
        popover.querySelector('.popover-price').textContent = price;
        const stockElement = popover.querySelector('.popover-stock');
        stockElement.textContent = stockStatus;
        stockElement.className = `popover-stock stock-status ${stockClass}`;
        popover.querySelector('.popover-sku').textContent = `SKU: ${sku}`;

        // Position popover
        const rect = item.getBoundingClientRect();
        popover.style.left = `${rect.left + rect.width / 2}px`;
        popover.style.top = `${rect.top - 10}px`;
        popover.classList.add('visible');
    }

    hidePopover() {
        document.getElementById('builderPopover').classList.remove('visible');
    }

    updateCompatibility() {
        // Get all currently selected SKUs
        const selectedSKUs = new Set();
        this.selectedItems.forEach((items) => {
            items.forEach(item => {
                if (item.sku) {
                    selectedSKUs.add(item.sku);
                }
            });
        });

        // Check each option item for compatibility
        document.querySelectorAll('.option-item:not(.clear-selection)').forEach(item => {
            const itemSKU = item.dataset.variantSku;

            if (!itemSKU || !this.compatibilityRules.length) {
                item.classList.remove('disabled-option');
                item.removeAttribute('title');
                return;
            }

            // Check if this item has any compatibility requirements
            const rule = this.compatibilityRules.find(r => r.product === itemSKU);

            if (rule && rule.requires) {
                // Check if the required SKU is selected
                if (!selectedSKUs.has(rule.requires)) {
                    item.classList.add('disabled-option');
                    item.setAttribute('title', `Requires ${rule.requires}`);
                } else {
                    item.classList.remove('disabled-option');
                    item.removeAttribute('title');
                }
            } else {
                item.classList.remove('disabled-option');
                item.removeAttribute('title');
            }
        });
    }

    updateSummary() {
        const summaryItemsDiv = document.getElementById('summaryItems');
        const totalPriceSpan = document.getElementById('totalPrice');
        const addToCartBtn = document.getElementById('addAllToCart');

        if (this.selectedItems.size === 0) {
            summaryItemsDiv.innerHTML = '<p class="summary-empty">No items selected</p>';
            totalPriceSpan.textContent = '$0.00';
            addToCartBtn.disabled = true;
            return;
        }

        let total = 0;
        let itemsHTML = '';

        this.selectedItems.forEach((items) => {
            items.forEach(item => {
                // Parse price (remove $ and convert to number)
                const priceValue = parseFloat(item.price.replace(/[^0-9.]/g, ''));
                total += priceValue;

                const displayTitle = item.productTitle && item.title !== item.productTitle
                    ? `${item.productTitle} - ${item.title}`
                    : item.productTitle || item.title;

                                const quantity = parseInt(item.quantity) || 0;
                                const stockStatus = quantity >= 1 ? 'In stock' : 'Backorder';
                                const stockClass = quantity >= 1 ? 'in-stock' : 'back-ordered';

                itemsHTML += `
            <div class="summary-item">
              <img src="${item.image}" alt="${displayTitle}">
              <div class="summary-item-details">
                <p class="summary-item-title">${displayTitle}</p>
                                <div class="summary-item-meta">
                                    <p class="summary-item-price">${item.price}</p>
                                    <p class="summary-item-stock stock-status ${stockClass}">${stockStatus}</p>
                                </div>
              </div>
            </div>
          `;
            });
        });

        summaryItemsDiv.innerHTML = itemsHTML;
        totalPriceSpan.textContent = `$${total.toFixed(2)}`;
        addToCartBtn.disabled = false;
    }

    async addAllToCart() {
        const btn = document.getElementById('addAllToCart');
        const originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;

        try {
            const items = [];
            this.selectedItems.forEach((stepItems) => {
                stepItems.forEach(item => {
                    items.push({
                        id: item.variantId,
                        quantity: 1
                    });
                });
            });

            // Reverse the order of items before adding to cart
            items.reverse();

            // Get cart sections to update
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const formData = { items };

            if (cart && typeof cart.getSectionsToRender === 'function') {
                formData.sections = cart.getSectionsToRender().map((section) => section.id);
                formData.sections_url = window.location.pathname;
            }

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                const responseData = await response.json();
                btn.textContent = 'Added!';

                // Update cart count and related UI elements
                fetch('/cart.json')
                    .then((res) => res.json())
                    .then((cart) => {
                        if (cart.item_count !== undefined) {
                            document.querySelectorAll('.cart-count').forEach((el) => {
                                if (el.classList.contains('cart-count-drawer')) {
                                    el.innerHTML = `(${cart.item_count})`;
                                } else {
                                    el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
                                }
                            });

                            if (document.querySelector('header-total-price')) {
                                document.querySelector('header-total-price').updateTotal(cart);
                            }

                            const cart_free_ship = document.querySelector('free-ship-progress-bar');
                            if (cart_free_ship) {
                                cart_free_ship.init(cart.items_subtotal_price);
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error updating cart count:', error);
                    });

                // Trigger cart update event if available
                if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        cartData: responseData
                    });
                }

                // Update cart drawer sections and open it
                const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if (cart && typeof cart.getSectionsToRender === 'function') {
                    cart.getSectionsToRender().forEach((section) => {
                        const elementToReplace = document.getElementById(section.id);
                        if (elementToReplace && responseData.sections && responseData.sections[section.id]) {
                            const html = new DOMParser().parseFromString(
                                responseData.sections[section.id],
                                "text/html"
                            );
                            const minicartForm = html.querySelector("#minicart-form");
                            if (minicartForm) {
                                elementToReplace.innerHTML = minicartForm.innerHTML;
                            }
                        }
                    });

                    if (typeof cart.cartAction === 'function') {
                        cart.cartAction();
                    }

                    if (cart.classList.contains("is-empty")) {
                        cart.classList.remove("is-empty");
                    }

                    setTimeout(() => {
                        if (typeof cart.open === 'function') {
                            cart.open();
                        }

                        const cartRecommend = document.querySelector(".cart-recommend");
                        if (cartRecommend && !cartRecommend.classList.contains("hidden-recommend")) {
                            if (cartRecommend.classList.contains("cart-recommend-custom")) {
                                const cartUpsellItem = document.querySelectorAll(".cart-upsell-item");
                                const cartUpsellSlide = document.querySelectorAll(".swiper-cart-upsell .swiper-slide");
                                if (cartUpsellItem.length > 0) {
                                    setTimeout(function () {
                                        cartRecommend.classList.add("open");
                                    }, 800);
                                } else if (cartUpsellSlide.length === 0) {
                                    cartRecommend.classList.remove("block");
                                    cartRecommend.classList.add("hidden");
                                }
                            } else {
                                setTimeout(function () {
                                    cartRecommend.classList.add("open");
                                }, 800);
                            }
                        }
                    }, 0);
                }

                // Reset button after 2 seconds
                setTimeout(() => {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 2000);
            } else {
                // Parse error response
                const errorData = await response.json();
                this.showErrorModal(errorData.message || errorData.description || 'Failed to add items to cart. Please try again.');
                btn.textContent = originalText;
                btn.disabled = false;
            }
        } catch (error) {
            console.error('Error adding to cart:', error);
            this.showErrorModal('An unexpected error occurred. Please try again.');
            btn.textContent = originalText;
            btn.disabled = false;
        }
    }

    showErrorModal(message) {
        const modal = document.getElementById('errorModal');
        const messageDiv = document.getElementById('errorMessage');
        messageDiv.textContent = message;
        modal.classList.add('visible');
    }

    hideErrorModal() {
        const modal = document.getElementById('errorModal');
        modal.classList.remove('visible');
    }

    openCartDrawer() {
        // Get the cart notification element (used by this theme)
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart && typeof cart.open === 'function') {
            cart.open();
        }
    }
}

// Initialize the builder when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new HandCannonBuilder());
} else {
    new HandCannonBuilder();
}